import { createAsyncThunk } from '@reduxjs/toolkit';
import doFetch from 'utils/api/doFetch';

import type {
  GetPairDeviceToRfidResponseResponseType,
  PairDeviceToRfidRequestBody,
} from 'redux-store/slices/rfids/types';

const pairDevicesToRfidsThunk = createAsyncThunk(
  'organizationOverview/pairDevicesToRfidsThunk',
  async ({
    data,
  }: {
    data: PairDeviceToRfidRequestBody;
  }): Promise<GetPairDeviceToRfidResponseResponseType> => {
    try {
      const apiPointName = 'pairDevicesToRfids';

      return await doFetch<typeof apiPointName>({
        apiPointName,
        body: data,
      });
    } catch (e) {
      return Promise.reject(e);
    }
  },
);

export default pairDevicesToRfidsThunk;
